(function () {
  function initQuickView() {

    /* ── 多語設定：從 snippets/qv-strings.liquid 輸出的 JSON 讀取 ── */
    var root = '/';
    var locale = 'zh-TW';
    var template = '';

    /* ── 哪些頁面的 .card-wrapper 商品卡要開 popup；其他頁面（分類、搜尋、商品推薦）直接前往商品詳情頁 ── */
    var QV_CARD_TEMPLATES = ['index'];
    var T = {
      loading: '載入中...',
      load_failed: '載入失敗，請重試',
      close: '關閉',
      photo_alt: '照片 [n]',
      photo_nav: '第 [n] 張照片',
      prev_photo: '上一張照片',
      next_photo: '下一張照片',
      sold_out_suffix: '（售完）',
      add_to_cart: '加入購物車',
      sold_out: '已售完',
      adding: '加入中...',
      add_failed: '加入失敗',
      added: '已加入購物車',
      continue_shopping: '繼續選購',
      go_checkout: '前往結帳',
      cart_items: '[n] 件商品'
    };

    (function loadI18n() {
      var el = document.getElementById('qv-strings');

      if (el) {
        try {
          var data = JSON.parse(el.textContent);
          if (data.root) root = data.root;
          if (data.locale) locale = data.locale;
          if (data.template) template = data.template;
          if (data.strings) T = Object.assign(T, data.strings);
        } catch (e) {}
      }

      /* Shopify 全域路由優先（自動帶語系前綴，如 /en/） */
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        root = window.Shopify.routes.root;
      }
      if (root.charAt(root.length - 1) !== '/') root += '/';
    })();

    function fill(str, n) {
      return String(str).replace('[n]', n);
    }

    var overlay = document.createElement('div');
    overlay.className = 'qv-overlay';
    document.body.appendChild(overlay);

    var modal = null;

    overlay.addEventListener('click', closeModal);

    document.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('.card-wrapper a[href*="/products/"]') : null;

      if (!link) return;
      if (QV_CARD_TEMPLATES.indexOf(template) === -1) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var href = link.getAttribute('href');
      var handle = href.split('/products/')[1].split('?')[0].split('#')[0];

      openModal(handle);
    }, true);

    /* ── 接收 YTA 自訂區塊(三聯畫、配件帶等)的開窗事件 ── */
    document.addEventListener('yta:quickview', function (e) {
      if (e.detail && e.detail.handle) {
        openModal(e.detail.handle);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function imgUrl(url, width) {
      if (!url) return '';
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
    }

    /* ── 價格區塊:有特價時「特價在前、原價刪除線在後」 ── */
    function priceHtml(variant) {
      if (!variant) return '';

      var hasSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (hasSale) {
        return '<span class="qv-price-now">' + formatMoney(variant.price) + '</span>' +
               '<s class="qv-price-was">' + formatMoney(variant.compare_at_price) + '</s>';
      }

      return '<span class="qv-price-now">' + formatMoney(variant.price) + '</span>';
    }

    function openModal(handle) {
      closeModal();

      modal = document.createElement('div');
      modal.className = 'qv-modal';
      modal.innerHTML = '<div class="qv-loading">' + T.loading + '</div>';
      document.body.appendChild(modal);

      document.body.style.overflow = 'hidden';

      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        modal.classList.add('is-open');
      });

      /* 依目前語系抓商品資料：/en/products/xxx.js 會回傳翻譯後的標題與描述 */
      fetch(root + 'products/' + handle + '.js')
        .then(function (res) {
          return res.json();
        })
        .then(function (product) {
          var first =
            product.variants.find(function (v) { return v.available; }) ||
            product.variants[0];

          var title = escapeHtml(product.title);

          /* ── 照片來源:後台商品的所有照片,順序照後台排序 ── */
          var images = (product.images && product.images.length)
            ? product.images
            : (product.featured_image ? [product.featured_image] : []);

          var slidesHtml = images.map(function (src, i) {
            return '<div class="qv-slide">' +
              '<img src="' + imgUrl(src, 900) + '" alt="' + title + ' ' + fill(T.photo_alt, i + 1) + '" loading="' + (i === 0 ? 'eager' : 'lazy') + '">' +
            '</div>';
          }).join('');

          var dotsHtml = images.map(function (_, i) {
            return '<button type="button" data-index="' + i + '" aria-label="' + fill(T.photo_nav, i + 1) + '"></button>';
          }).join('');

          var variantSelect = '';

          if (product.variants.length > 1) {
            variantSelect =
              '<select class="qv-variant">' +
              product.variants.map(function (v) {
                return '<option value="' + v.id + '"' +
                  (v.available ? '' : ' disabled') +
                  (v.id === first.id ? ' selected' : '') +
                  '>' + escapeHtml(v.title) + (v.available ? '' : T.sold_out_suffix) + '</option>';
              }).join('') +
              '</select>';
          }

          modal.innerHTML =
            '<div class="qv-grabber" aria-hidden="true"></div>' +
            '<button class="qv-close" type="button" aria-label="' + T.close + '">&times;</button>' +
            '<div class="qv-inner">' +
              '<div class="qv-media">' +
                (images.length > 1 ? '<span class="qv-count">1 / ' + images.length + '</span>' : '') +
                '<div class="qv-track">' + slidesHtml + '</div>' +
                (images.length > 1 ?
                  '<button class="qv-arrow qv-prev" type="button" aria-label="' + T.prev_photo + '" disabled>' +
                    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 3 5 8l5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                  '</button>' +
                  '<button class="qv-arrow qv-next" type="button" aria-label="' + T.next_photo + '">' +
                    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                  '</button>' +
                  '<div class="qv-dots">' + dotsHtml + '</div>'
                : '') +
              '</div>' +
              '<div class="qv-panel">' +
                '<div class="qv-scroll">' +
                  '<h2 class="qv-title">' + title + '</h2>' +
                  '<div class="qv-price">' + priceHtml(first) + '</div>' +
                  '<div class="qv-desc">' + (product.description || '') + '</div>' +
                '</div>' +
                '<div class="qv-footer">' +
                  variantSelect +
                  '<button class="qv-atc" type="button" data-id="' + first.id + '" ' + (first.available ? '' : 'disabled') + '>' +
                    (first.available ? T.add_to_cart : T.sold_out) +
                  '</button>' +
                '</div>' +
              '</div>' +
            '</div>';

          modal.querySelector('.qv-close').addEventListener('click', closeModal);
          reConvertPrices();

          if (images.length > 1) initGallery(modal, images.length);
          initSwipeDismiss(modal);

          var select = modal.querySelector('.qv-variant');
          var price = modal.querySelector('.qv-price');
          var atc = modal.querySelector('.qv-atc');

          if (select) {
            select.addEventListener('change', function () {
              var option = select.selectedOptions[0];

              var variant = product.variants.find(function (v) {
                return String(v.id) === option.value;
              });

              atc.setAttribute('data-id', option.value);
              atc.disabled = option.disabled;
              atc.textContent = option.disabled ? T.sold_out : T.add_to_cart;
              price.innerHTML = priceHtml(variant);
              reConvertPrices();
            });
          }

          atc.addEventListener('click', function () {
            var oldText = atc.textContent;

            atc.disabled = true;
            atc.textContent = T.adding;

            fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: Number(atc.getAttribute('data-id')),
                quantity: 1,
                sections: 'cart-icon-bubble,cart-drawer'
              })
            })
              .then(function (res) {
                if (!res.ok) throw new Error('Add to cart failed');
                return res.json();
              })
              .then(function (data) {
                updateCartBubble(data.sections && data.sections['cart-icon-bubble']);
                updateCartDrawer(data.sections && data.sections['cart-drawer']);
                reConvertPrices();
                atc.disabled = false;
                atc.textContent = oldText;
                showAddedMessage(atc);
              })
              .catch(function () {
                atc.disabled = false;
                atc.textContent = T.add_failed;

                setTimeout(function () {
                  atc.textContent = oldText;
                }, 1500);
              });
          });

          function showAddedMessage(atc) {
            var oldMessage = modal.querySelector('.qv-added-message');
            if (oldMessage) oldMessage.remove();

            modal.classList.add('qv-added-state');

            var message = document.createElement('div');
            message.className = 'qv-added-message';
            message.innerHTML =
              '<p>' + T.added + '</p>' +
              '<div class="qv-added-actions">' +
                '<button type="button" class="qv-continue">' + T.continue_shopping + '</button>' +
                '<a class="qv-checkout" href="' + root + 'checkout">' + T.go_checkout + '</a>' +
              '</div>';

            atc.insertAdjacentElement('afterend', message);

            message.querySelector('.qv-continue').addEventListener('click', closeModal);
          }
        })
        .catch(function () {
          if (modal) modal.innerHTML = '<div class="qv-loading">' + T.load_failed + '</div>';
        });
    }

    /* ── 照片輪播:scroll-snap + 圓點 + 箭頭 + 計數 ── */
    function initGallery(modal, total) {
      var track = modal.querySelector('.qv-track');
      var count = modal.querySelector('.qv-count');
      var btnPrev = modal.querySelector('.qv-prev');
      var btnNext = modal.querySelector('.qv-next');
      var dots = modal.querySelectorAll('.qv-dots button');
      var current = 0;
      var raf;

      function render() {
        for (var i = 0; i < total; i++) {
          dots[i].classList.toggle('is-active', i === current);
        }
        count.textContent = (current + 1) + ' / ' + total;
        btnPrev.disabled = current === 0;
        btnNext.disabled = current === total - 1;
      }

      function goTo(i) {
        current = Math.max(0, Math.min(total - 1, i));
        track.scrollTo({ left: track.clientWidth * current, behavior: 'smooth' });
        render();
      }

      btnPrev.addEventListener('click', function () { goTo(current - 1); });
      btnNext.addEventListener('click', function () { goTo(current + 1); });

      for (var i = 0; i < dots.length; i++) {
        (function (idx) {
          dots[idx].addEventListener('click', function () { goTo(idx); });
        })(i);
      }

      /* 手勢滑動後同步圓點與計數 */
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== current) { current = i; render(); }
        });
      });

      /* 鍵盤左右鍵切換 */
      modal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') goTo(current - 1);
        if (e.key === 'ArrowRight') goTo(current + 1);
      });

      render();
    }

    /* ── 手機:往下滑關閉彈窗 ── */
    function initSwipeDismiss(modal) {
      var scrollArea = modal.querySelector('.qv-scroll');
      var startY = 0;
      var startX = 0;
      var deltaY = 0;
      var axis = null;
      var dragging = false;

      modal.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        if (!window.matchMedia('(max-width: 720px)').matches) return;

        startY = e.touches[0].clientY;
        startX = e.touches[0].clientX;
        deltaY = 0;
        axis = null;
        dragging = false;
      }, { passive: true });

      modal.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 1) return;
        if (!window.matchMedia('(max-width: 720px)').matches) return;

        var dy = e.touches[0].clientY - startY;
        var dx = e.touches[0].clientX - startX;

        /* 先判斷手勢方向:橫向交給照片輪播,縱向才處理 */
        if (!axis) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          axis = Math.abs(dy) > Math.abs(dx) ? 'y' : 'x';
        }
        if (axis !== 'y') return;

        /* 文字區還沒捲到頂時,往下滑是捲文字,不拖彈窗 */
        if (!dragging && scrollArea && scrollArea.contains(e.target) && scrollArea.scrollTop > 0) return;

        /* 往上滑不觸發 */
        if (!dragging && dy <= 0) return;

        dragging = true;
        deltaY = Math.max(0, dy);
        modal.classList.add('qv-dragging');
        modal.style.transform = 'translateY(' + deltaY + 'px)';
        e.preventDefault();
      }, { passive: false });

      modal.addEventListener('touchend', function () {
        if (!dragging) return;

        modal.classList.remove('qv-dragging');
        modal.style.transform = '';

        if (deltaY > 110) {
          closeModal();
        }

        dragging = false;
        deltaY = 0;
      });
    }

    /* ── 更新 header 購物車圖示與數量 ── */
    function updateCartBubble(sectionHtml) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;

      if (sectionHtml) {
        var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
        var fresh = doc.querySelector('.shopify-section');
        if (fresh) {
          bubble.innerHTML = fresh.innerHTML;
          return;
        }
      }

      /* 後備方案:直接查購物車數量,手動補上數字泡泡 */
      fetch(root + 'cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var count = bubble.querySelector('.cart-count-bubble span[aria-hidden]');
          if (count) {
            count.textContent = cart.item_count;
          } else if (cart.item_count > 0) {
            var div = document.createElement('div');
            div.className = 'cart-count-bubble';
            div.innerHTML =
              '<span aria-hidden="true">' + cart.item_count + '</span>' +
              '<span class="visually-hidden">' + fill(T.cart_items, cart.item_count) + '</span>';
            bubble.appendChild(div);
          }
        })
        .catch(function () {});
    }

    /* ── 更新滑出式購物車內容 ── */
    function updateCartDrawer(sectionHtml) {
      if (!sectionHtml) return;

      var current = document.querySelector('cart-drawer');
      if (!current) return;

      var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var fresh = doc.querySelector('cart-drawer');
      if (!fresh) return;

      current.innerHTML = fresh.innerHTML;
      current.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
    }

    function closeModal() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';

      if (modal) {
        modal.remove();
        modal = null;
      }
    }

       function formatMoney(cents) {
      var amount = Math.round(cents / 100).toLocaleString('en-US');
      return '<span class="money">NT$' + amount + '</span>';
    }

    /* 通知 BUCKS 重新換算幣別 */
    function reConvertPrices() {
      if (window.bucksCC && typeof window.bucksCC.reConvert === 'function') {
        window.bucksCC.reConvert();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickView);
  } else {
    initQuickView();
  }
})();